"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8784],{

/***/ 58296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8334);



var IsNotMobile = function(param) {
    var children = param.children, height = param.height, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .NotMobileContainer */ .Dm, {
        height: height,
        width: width,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IsNotMobile);


/***/ }),

/***/ 14139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l7": function() { return /* reexport */ ResponsiveContainers_IsDesktop; },
  "hD": function() { return /* reexport */ ResponsiveContainers_IsMobile; },
  "oH": function() { return /* reexport */ IsNotMobile/* default */.Z; },
  "Tm": function() { return /* reexport */ ResponsiveContainers_IsPad; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/ResponsiveContainers/styled.js
var styled = __webpack_require__(8334);
;// CONCATENATED MODULE: ./components/ResponsiveContainers/IsDesktop.js



var IsDesktop = function(param) {
    var children = param.children, height = param.height, width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* DesktopContainer */.C5, {
        height: height,
        width: width,
        children: children
    });
};
/* harmony default export */ var ResponsiveContainers_IsDesktop = (IsDesktop);

;// CONCATENATED MODULE: ./components/ResponsiveContainers/IsPad.js



var IsPad = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* PadContainer */.gF, {
        children: children
    });
};
/* harmony default export */ var ResponsiveContainers_IsPad = (IsPad);

;// CONCATENATED MODULE: ./components/ResponsiveContainers/IsMobile.js



var IsMobile = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* MobileContainer */.OJ, {
        children: children
    });
};
/* harmony default export */ var ResponsiveContainers_IsMobile = (IsMobile);

// EXTERNAL MODULE: ./components/ResponsiveContainers/IsNotMobile.js
var IsNotMobile = __webpack_require__(58296);
;// CONCATENATED MODULE: ./components/ResponsiveContainers/index.js






/***/ }),

/***/ 8334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C5": function() { return /* binding */ DesktopContainer; },
/* harmony export */   "Dm": function() { return /* binding */ NotMobileContainer; },
/* harmony export */   "OJ": function() { return /* binding */ MobileContainer; },
/* harmony export */   "gF": function() { return /* binding */ PadContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52261);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  ",
        ";\n  ",
        ";\n  @media only screen and (max-width: 768px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  @media only screen and (min-width: 560px) and (max-width: 768px) {\n    display: block;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  @media only screen and (max-width: 560px) {\n    display: block;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  ",
        ";\n  ",
        ";\n  @media only screen and (max-width: 560px) {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var DesktopContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7f254217-0"
})(_templateObject(), function(param) {
    var height = param.height;
    return height && "height: ".concat(height);
}, function(param) {
    var width = param.width;
    return width && "width: ".concat(width);
});
var PadContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7f254217-1"
})(_templateObject1());
var MobileContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7f254217-2"
})(_templateObject2());
var NotMobileContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7f254217-3"
})(_templateObject3(), function(param) {
    var height = param.height;
    return height && "height: ".concat(height);
}, function(param) {
    var width = param.width;
    return width && "width: ".concat(width);
});


/***/ }),

/***/ 88784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_ResponsiveContainers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14139);
/* harmony import */ var _styled_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49992);





function AppSection() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled_js__WEBPACK_IMPORTED_MODULE_4__/* .AppSectionContainer */ .IP, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled_js__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx, {
                children: "Career Opportunities"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled_js__WEBPACK_IMPORTED_MODULE_4__/* .AppDetailSection */ .Cq, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "apply in-person",
                        children: "APPLY IN-PERSON"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "address",
                        children: "5585 Wells Park Rd "
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "address",
                        children: "West Jordan, UT 84081"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "address",
                        children: "8:00 AM – 5:00 PM"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "address click",
                        children: [
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "http://maps.google.com/?q=5585 Wells Park Rd, West Jordan, UT 84081",
                                children: "Click for Directions "
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "apply online",
                        children: "APPLY ONLINE"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "address click",
                        children: [
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "/files/Application-Classy-Closets.pdf",
                                download: true,
                                children: "Click to Download Application "
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled_js__WEBPACK_IMPORTED_MODULE_4__/* .ImageWrap */ .xM, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "/images/careers/featured.webp",
                    layout: "fill",
                    className: "banner-image",
                    alt: "banner image",
                    objectFit: "cover",
                    quality: 60
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (AppSection);


/***/ }),

/***/ 49992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ AppDetailSection; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "IP": function() { return /* binding */ AppSectionContainer; },
/* harmony export */   "xM": function() { return /* binding */ ImageWrap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52261);
/* harmony import */ var _ProductCategoryPage_TitleBannerSection_styled_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13179);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nwidth: 100%;\nheight: 80vh;\ndisplay: block;\nmargin-top: 30px;\n/* border: 1px solid black; */\nposition: relative;\n\n@media only screen and (max-width: 560px) {\n  display: inline-block;\n  margin-bottom: 3%;\n  height: 100vh;\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\ntext-align: center;\nfont-size: 28px;\n\n@media only screen and (max-width: 768px) {\n  font-size: 24px;\n}\n\n@media only screen and (max-width: 768px) {\n  font-size: 22px;\n  margin-bottom: 20px;\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nposition: absolute;\nwidth: 56%;\nheight: 60%;\nright: 0;\nmargin-top: 4%;\noverflow: hidden;\n\n@media only screen and (max-width: 560px) {\n  display: block;\n  position: relative;\n  margin: auto;\n  width: 100%;\n  /* bottom: 0; */\n  height: 50%;\n  margin-top: 4%;\n  margin-bottom: 3%;\n}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\nposition: absolute;\nleft: 120px;\nheight: 60%;\nmargin-top: 5%;\nwidth: 30%;\ncolor: black;\nwhite-space: nowrap;\n\n@media only screen and (max-width: 769px) {\n  left: 40px;\n}\n\n@media only screen and (max-width: 560px) {\n  display: block;\n  position: relative;\n  margin: auto;\n  margin-bottom: auto;\n  text-align: center;\n  height: 40%;\n  white-space: normal;\n  width: 80%;\n  left: 0px;\n}\n\n .apply {\n   font-size: 20px;\n   font-family: "Montserrat";\n   letter-spacing: 0px;\n   font-weight: 900;\n   text-align: left;\n   letter-spacing: .4px;\n  \n   @media only screen and (max-width: 560px) {\n     text-align: center;\n     font-size: 17px;\n   }\n\n   &.in-person {\n    margin-top: 10px;\n    margin-bottom: 10px;;\n   }\n\n   &.online {\n    margin-top: 50px;\n   }\n\n }\n.address {\n  font-family: "Helvetica";\n  margin-bottom: 5px;\n  font-size: 15px;\n  font-weight: 500;\n  letter-spacing: .6px;\n  color: black;\n\n  &.click>a, &.click {\n    text-decoration: underline;\n    color: black;\n    &:hover{\n      color: black;\n      cursor: pointer;\n    }\n  }\n   }\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var AppSectionContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1a50da1f-0"
})(_templateObject());
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_ProductCategoryPage_TitleBannerSection_styled_js__WEBPACK_IMPORTED_MODULE_1__/* .TitleText */ .e).withConfig({
    componentId: "sc-1a50da1f-1"
})(_templateObject1());
var ImageWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1a50da1f-2"
})(_templateObject2());
var AppDetailSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-1a50da1f-3"
})(_templateObject3());


/***/ }),

/***/ 13179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; },
/* harmony export */   "e": function() { return /* binding */ TitleText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52261);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: auto;\n  min-height: 55px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n\n  @media only screen and (max-width: 768px) {\n    min-height: 50px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "Lora medium";\n  font-size: 35px;\n  font-weight: bold;\n  color: ',
        ";\n  letter-spacing: .55rem;\n  text-align: center;\n\n  @media only screen and (max-width: 768px) {\n    font-size: 30px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed7fedda-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed7fedda-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.darkGray2;
});


/***/ })

}]);